module.exports = __webpack_public_path__ + "img/loupe.67306cf1.png";